import {
  FETCH_BODY_REGIONS,
  FETCH_BODY_REGIONS_FAILURE,
  FETCH_BODY_REGIONS_SUCCESS,
} from "./constants";

export const fetchBodyRegions = (payload, onSuccess) => ({
  type: FETCH_BODY_REGIONS,
  payload,
  onSuccess,
});

export const fetchBodyRegionsSuccess = (payload) => ({
  type: FETCH_BODY_REGIONS_SUCCESS,
  payload,
});

export const fetchBodyRegionsFailure = (payload) => ({
  type: FETCH_BODY_REGIONS_FAILURE,
  payload,
});
